__webpack_require__.p = "/monsterfriend/";